import { render, staticRenderFns } from "./imgInfo.vue?vue&type=template&id=3aaffe6e&scoped=true&"
import script from "./imgInfo.vue?vue&type=script&lang=js&"
export * from "./imgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaffe6e",
  null
  
)

export default component.exports